import L from 'leaflet';
import Vue from 'vue';
import Control from './control';
import MultimapMenuVue from '../../components/map/multimapMenu.vue'

const multimapMenu = Control.extend({
  options: {
    position: 'topleft'
  },
  onAdd: function() {
    this.container = L.DomUtil.create('div')
    this.subcontainer = L.DomUtil.create('div')
    this.container.appendChild(this.subcontainer)

    return this.container
  },
  mounted () {
    const MenuClass = Vue.extend(MultimapMenuVue)
    this._menu = new MenuClass({
      parent: this.options.vue,
      propsData: {
        map: this._map
      }
    })
    
    this._menu.$mount(this.subcontainer)
  },
  onRemove: function () {
    this._menu.$destroy()
  }
})

export default multimapMenu